const Currency = require('models/currency.coffee')

const ReservesForecast = function(getters) {
  const reserves = getters.rs;
  let reserves_balance = Math.round(reserves.balance);
  let not_entered_transactions = getters.transactions_not_entered.filter(tr => tr.isRelatedToVirtual(getters.rs.id));
  not_entered_transactions = _.groupBy(not_entered_transactions, 'date');
  const result = [
    {
      date: hm_date.constants.today,
      reserves_balance,
      trs: []
    }
  ];

  let current_date = hm_date.addMonths(new Date, -2);
  const end_date = hm_date.addMonths(new Date, 12);

  while (current_date < end_date) {
    const date = current_date;
    current_date = hm_date.addDays(current_date, 1);

    const trs = not_entered_transactions[hm_date.format(date)] || [];
    if (trs.length > 0) {
      for (let tr of trs) {
        const plan_amount_in_default_currency = tr.plan_amount * Currency.convert(1, tr.currency, getters.default_currency);
        if (tr.isIncome() || tr.isExpense()) {
          reserves_balance += plan_amount_in_default_currency;
        } else if (tr.isTransferBetweenVirtuals()) {
          if (tr.transfer_from_id === reserves.id) {
            reserves_balance -= plan_amount_in_default_currency;
          }
          if (tr.transfer_to_id === reserves.id) {
            reserves_balance += plan_amount_in_default_currency;
          }
        }
      }
      result.push({
        date: hm_date.format(date),
        reserves_balance: Math.round(reserves_balance),
        trs: _.orderBy(trs, 'plan_amount')
      });
    }
  }
  const minimum_day = _.orderBy(result, day => day.reserves_balance)[0] || {};
  if (minimum_day.reserves_balance < 0) {
    minimum_day.customBullet = require('assets/charts/deficit_icon.png');
    minimum_day.bulletSize = 35;
  } else if (minimum_day.reserves_balance > 0) {
    minimum_day.customBullet = require('assets/charts/surplus_icon.png');
    minimum_day.bulletSize = 35;
  }
  return {
    minimum_day,
    forecast_by_days: result
  };
};

export default ReservesForecast;
